"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableHeader = exports.SortStatus = void 0;
var _react = _interopRequireDefault(require("react"));
var _ArrowDownward = _interopRequireDefault(require("@material-ui/icons/ArrowDownward"));
var _ArrowUpward = _interopRequireDefault(require("@material-ui/icons/ArrowUpward"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SortStatus = exports.SortStatus = /*#__PURE__*/function (SortStatus) {
  SortStatus[SortStatus["None"] = 0] = "None";
  SortStatus[SortStatus["Ascending"] = 1] = "Ascending";
  SortStatus[SortStatus["Descending"] = 2] = "Descending";
  return SortStatus;
}({});
var TableHeader = exports.TableHeader = function TableHeader(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var tableHeaderCells = props.tableCells.map(function (tableHeaderCell, index) {
    if (tableHeaderCell.cssClass === undefined) {
      tableHeaderCell.cssClass = "";
    }
    if (tableHeaderCell.sortStatus == SortStatus.Ascending) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: "header-".concat(index)
      }, /*#__PURE__*/_react["default"].createElement("th", {
        className: tableHeaderCell.cssClass
      }, tableHeaderCell.value, /*#__PURE__*/_react["default"].createElement(_ArrowUpward["default"], null)));
    } else if (tableHeaderCell.sortStatus == SortStatus.Descending) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: "header-".concat(index)
      }, /*#__PURE__*/_react["default"].createElement("th", {
        className: tableHeaderCell.cssClass
      }, tableHeaderCell.value, /*#__PURE__*/_react["default"].createElement(_ArrowDownward["default"], null)));
    } else if (tableHeaderCell.empty) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: "header-".concat(index)
      }, /*#__PURE__*/_react["default"].createElement("td", {
        className: tableHeaderCell.cssClass
      }, tableHeaderCell.value));
    } else {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
        key: "header-".concat(index)
      }, /*#__PURE__*/_react["default"].createElement("th", {
        className: tableHeaderCell.cssClass
      }, tableHeaderCell.value));
    }
  });
  if (props.dropdownInUse) {
    tableHeaderCells.push( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "filler-content"
    }, /*#__PURE__*/_react["default"].createElement("td", {
      className: "filler-content"
    })));
  }
  return /*#__PURE__*/_react["default"].createElement("thead", {
    className: props.dropdownInUse ? "table-row-header" : "table-row-header no-dropdown"
  }, /*#__PURE__*/_react["default"].createElement("tr", null, tableHeaderCells));
};
//# sourceMappingURL=tableHeader.js.map